import { Routes } from '@angular/router';

import { CcdlErrorPageComponent } from '@cpm-pr1618001/ng-design-lib';

import { authGuardFn } from './app-auth.guard';
import { AboutUsContainerComponent } from './landing-page/about-us/about-us.container.component';
import { HomeContainer } from './landing-page/home/home.container';
import { LandingPageContainerComponent } from './landing-page/landing-page.container.component';

export const routes: Routes = [
  {
    path: 'LandingPage',
    component: LandingPageContainerComponent,
    canActivate: [authGuardFn],
    children: [
      { path: 'Home', component: HomeContainer },
      { path: 'AboutUs', component: AboutUsContainerComponent },
      {
        path: '',
        redirectTo: 'Home',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'error-page',
    component: CcdlErrorPageComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'LandingPage',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'LandingPage',
  },
];
